import React, { useState, useEffect } from 'react';
import { Card, Container, Header, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './Blog.css';

const isDev = process.env.NODE_ENV === 'development';
const isDocker = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
const publicApi = axios.create({
  baseURL: isDev
    ? `http://${isDocker ? 'dijon-backend' : 'localhost'}:8019/dijon-backend/api/`
    : `https://dijondreams.com/dijon-backend/api/`,
  headers: { 'Content-Type': 'application/json' }
});

function BlogListPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchPosts() {
      try {
        const res = await publicApi.get('blog/posts/');
        setPosts(res.data.results || res.data);
      } catch (e) {
        console.error('Failed to fetch blog posts:', e);
      }
      setLoading(false);
    }
    fetchPosts();
  }, []);

  return (
    <div className="blog-page">
      <Container text>
        <div className="blog-header">
          <Header as="h1">Dijon Dreams Blog</Header>
        </div>
        {loading ? (
          <Segment loading placeholder />
        ) : posts.length === 0 ? (
          <Segment textAlign="center">
            <Header as="h3">No posts yet. Check back soon!</Header>
          </Segment>
        ) : (
          <Card.Group itemsPerRow={1}>
            {posts.map(post => (
              <Card key={post.id} fluid className="blog-post-card" as={Link} to={`/blog/${post.slug}`}>
                <Card.Content>
                  <Card.Header>{post.title}</Card.Header>
                  <Card.Meta>
                    {post.author_name} &middot; {new Date(post.published_at || post.created_at).toLocaleDateString()}
                  </Card.Meta>
                  {post.excerpt && <Card.Description>{post.excerpt}</Card.Description>}
                </Card.Content>
              </Card>
            ))}
          </Card.Group>
        )}
      </Container>
    </div>
  );
}

export default BlogListPage;
